import type { Patient, PatientEncounter } from "@/resources/types";

import type { ExternalRegisterPatientSummary, ExternalRegisterSummary } from "./types";
import { getActiveExternalRegisterAlerts } from "./helpers";

export type PatientWithExternalRegisterSummary = Patient & Partial<ExternalRegisterPatientSummary>;

export type PatientEncounterWithExternalRegisterSummary = PatientEncounter & {
  patient?: PatientWithExternalRegisterSummary;
};

export const getPatientExternalRegisterAlerts = (
  patient?: Partial<ExternalRegisterPatientSummary> | null,
): ExternalRegisterSummary[] => {
  if (!patient?.hasExternalRegisterAlert || !Array.isArray(patient.externalRegisterAlerts)) return [];
  return getActiveExternalRegisterAlerts(patient.externalRegisterAlerts);
};

export const hasPatientExternalRegisterAlerts = (
  patient?: Partial<ExternalRegisterPatientSummary> | null,
): boolean => getPatientExternalRegisterAlerts(patient).length > 0;
